import { AutocompleteField } from "@models/autocompleteField"
import { IData, IDataFields } from "@models/IDataFields"

export abstract class DataFields implements IDataFields {
  errorMessage: string
  errors: string[]

  _errorDataFieldMap: Map<string, string>

  abstract toArray(): IData[]
  abstract toJson(): {
    [key: string]: boolean | AutocompleteField | AutocompleteField[] | string
  }

  protected _toValidity(
    key: string,
    value: boolean,
    isRequired = true,
  ): { key: string; value: boolean; error: string; isRequired: boolean } {
    return {
      key,
      value,
      error: this._errorDataFieldMap.has(key)
        ? this._errorDataFieldMap.get(key)
        : "",
      isRequired: isRequired,
    }
  }

  checkValidity(): boolean {
    this.errors = []
    let isInvalid = false
    this.toArray().forEach((property, i, list) => {
      if (!property.value && property.isRequired) {
        this.errors.push(property.error)
        isInvalid = true
      }
    })
    return !isInvalid
  }

  getError(): string {
    return (
      this.errorMessage +
      " " +
      (this.errors.length === 1
        ? this.errors[0]
        : "Pouvez-vous compléter svp ?")
    )
  }
}
